import create from 'zustand';
import {
    devtools
} from "zustand/middleware"

let store = (set) => ({
    newMessage: false,
    newNotification: false,
    setNewMessage: (payload) => set(state => ({
        newMessage: payload
    })),
    setNewNotification: (payload) => set(state => ({
        newNotification: payload
    })),
});


store = devtools(store);

let authStore = create(store);

export default authStore;